export default class Widgets {
    static all() {
        return {
            "package-map-widget": {
                "name": "Map",
                "group" : "Package",
                "icon": "fas fa-map",
                "maxW": 3,
                "maxH": 9,
                "minW": 1,
                "minH": 2,
            },
            "package-files-widget": {
                "name": "Files",
                "group" : "Package",
                "icon": "far fa-folder-open",
                "maxW": 3,
                "maxH": 9,
                "minW": 1,
                "minH": 4,
            },
            "package-notes-widget": {
                "name": "Notes",
                "group" : "Package",
                "icon": "far fa-comments",
                "maxW": 2,
                "maxH": 9,
                "minW": 1,
                "minH": 2,
            },
            "package-tasks-widget": {
                "name": "Tasks",
                "group" : "Package",
                "icon": "far fa-check",
                "maxW": 1,
                "maxH": 6,
                "minW": 1,
                "minH": 1,
            },
            "package-latest-progress-report-widget": {
                "name": "Latest Progress Report",
                "group" : "Operations",
                "icon": "fas fa-receipt",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-contacts-widget": {
                "name": "Contacts",
                "group" : "Package",
                "icon": "far fa-address-card",
                "maxW": 2,
                "maxH": 6,
                "minW": 1,
                "minH": 2,
            },
            "package-pending-pos-widget": {
                "name": "Pending Purchase Orders",
                "group" : "Accounts",
                "icon": "fas fa-pound-sign",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-payment-cert-uncertified-widget": {
                "name": "Payment Cert Uncertified",
                "group" : "Accounts",
                "icon": "far fa-calendar-check",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-defects-count-widget": {
                "name": "Open Defects",
                "group" : "Operations",
                "icon": "far fa-diagnoses",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-equipment-on-site-count-widget": {
                "name": "Equipment On Site",
                "group" : "Operations",
                "icon": "far fa-wrench",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-bookings-needing-actioning-widget": {
                "name": "Bookings needing Actioning",
                "group" : "Operations",
                "icon": "fas fa-person-carry",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-crm-system-in-use-widget": {
                "name": "CRM System in use",
                "group" : "Operations",
                "icon": "fas fa-external-link-square-alt",
                "maxW": 1,
                "maxH": 1,
                "minW": 1,
                "minH": 1,
            },
            "package-user-calendar-widget": {
                "name": "Calendar",
                "group" : "Package",
                "icon": "fas fa-calendar",
                "maxW": 3,
                "maxH": 9,
                "minW": 1,
                "minH": 3,
            },

        }
    }
}